module.exports = __webpack_public_path__ + "img/电视机背板2.c9f385a3.jpg";